module.exports = __webpack_public_path__ + "static/media/metcap.4a147687.png";